import React from 'react';
import { motion } from 'framer-motion';
import { Target, Activity, ShieldCheck } from 'lucide-react';
import { SectionReveal } from '../ui/SectionReveal';
const steps = [{
  day: 'Día 1-2',
  title: 'Preparación y Escudo',
  desc: 'Identificamos tus disparadores y preparamos tu cuerpo con los primeros suplementos base.',
  icon: ShieldCheck,
  color: 'from-blue-400 to-blue-600'
}, {
  day: 'Día 3-5',
  title: 'Reprogramación',
  desc: 'Implementamos el orden de alimentos y las dosis de refuerzo para mejorar la sensibilidad a la insulina.',
  icon: Activity,
  color: 'from-[#D4A017] to-yellow-600'
}, {
  day: 'Día 6-7',
  title: 'Estabilización',
  desc: 'Estabilizamos los niveles y creamos tu plan de mantenimiento personalizado para las siguientes semanas.',
  icon: Target,
  color: 'from-[#10B981] to-emerald-600'
}];
export function TimelineSection() {
  return <SectionReveal bgColor="white" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <div className="text-center mb-16" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A1A2E] mb-4" data-id="element-195">
            Tu viaje de <span className="text-[#0D6E6E]" data-id="element-196">7 Días</span>
          </h2>
          <p className="text-lg text-gray-600" data-id="element-197">
            Un proceso claro, estructurado y fácil de seguir.
          </p>
        </div>

        <div className="relative" data-id="element-198">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gray-100 -translate-y-1/2 z-0" data-id="element-199" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-200">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center" data-id="element-201">
                {/* Connecting Line (Mobile) */}
                {index !== steps.length - 1 && <div className="md:hidden absolute top-24 left-1/2 w-0.5 h-full bg-gray-100 -translate-x-1/2 -z-10" data-id="element-202" />}

                <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${step.color} p-1 shadow-lg mb-6`} data-id="element-203">
                  <div className="w-full h-full bg-white rounded-full flex items-center justify-center" data-id="element-204">
                    <step.icon className="w-8 h-8 text-[#1A1A2E]" data-id="element-205" />
                  </div>
                </div>

                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 w-full" data-id="element-206">
                  <span className="inline-block px-3 py-1 bg-gray-100 text-gray-800 text-sm font-bold rounded-full mb-3" data-id="element-207">
                    {step.day}
                  </span>
                  <h3 className="text-xl font-bold text-[#1A1A2E] mb-3" data-id="element-208">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm" data-id="element-209">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </SectionReveal>;
}